import React from 'react'
import { useRecoilValue } from 'recoil'

import { H3 } from '@hub/heading'
import { Stack } from '@hub/stack'
import { CONFIG_KEYS, getClientConfigBool } from '@scentregroup/shared/config'

import ProfileEmail from '../../components/profile/profile-email'
import ProfileName from '../../components/profile/profile-name'
import SpinnerDelayed from '../../components/spinner-delayed'
import { userAtom, loadingUserAtom } from '../../lib/atoms/user-info'
import ProfileMobile from './profile-mobile'
import { ERROR_RETRIEVE_PROFILE } from '../../lib/error-messages'

const Profile: React.FC<React.PropsWithChildren<unknown>> = () => {
  const userLoading = useRecoilValue(loadingUserAtom)
  const { data: user, error } = useRecoilValue(userAtom)

  const isMobileEnabled = getClientConfigBool(
    CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_ACCOUNT_PROFILE_MOBILE_ENABLED
  )

  if (userLoading) {
    return <SpinnerDelayed />
  }

  if (error || !user) {
    console.error(error?.message)
    throw new Error(ERROR_RETRIEVE_PROFILE)
  }

  return (
    <>
      <H3 sx={{ marginBottom: 'spacing-xl' }}>Profile</H3>
      <Stack>
        <ProfileName />
        <ProfileEmail />
        {isMobileEnabled && <ProfileMobile />}
      </Stack>
    </>
  )
}

export default Profile
